import { FC } from "react";

import { OutcomeChipList } from "../outcomes/OutcomeChipList";
import { useStudentAverageOutcomeScores } from "../outcomes/use-student-average-outcome-scores";

import { OutcomeType } from "components/server-types";
import { HomeRole, homeOutcomesUrl } from "utils/urls";

export type StudentOutcomeChipListProps = {
  outcomes: OutcomeType[];
  currentUserId: string | null;
  selectedOutcomeId?: string;
};

export const StudentOutcomeChipList: FC<StudentOutcomeChipListProps> = ({
  outcomes,
  currentUserId,
  selectedOutcomeId,
}) => {
  const outcomeScoreMap = useStudentAverageOutcomeScores(currentUserId);

  return (
    <OutcomeChipList
      getOutcomeUrl={(outcome) => homeOutcomesUrl(HomeRole.STUDENT, outcome.id)}
      outcomes={outcomes}
      scoreMap={outcomeScoreMap}
      selectedOutcomeId={selectedOutcomeId}
      size="m"
    />
  );
};
